<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="section" v-on:click="goTo('/inventory/action/list')">Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Editar Actuación</a>
    </div>

    <h1 class="ui header">
      <i class="icon edit outline"></i>
      <div class="content">Editar Actuación</div>
    </h1>

    <div v-if="!data" class="ui active centered inline loader"></div>

    <div v-if="data" class="ui icon buttons rightButton">
      <button id="idBtnCloseAction" class="ui black button" :class="{ loading: isBtnCloseActionLoading }"
        :disabled="action_closed || btnEditAction" v-on:click="closeAction">
        <i class="lock alternate icon"></i>
        {{ txtBtnCloseAction }}
      </button>
      <button id="idBtnEditAction" class="ui blue button" :disabled="btnEditAction" v-on:click="editAction">
        <i class="large icons">
          <i class="edit icon"></i>
        </i>
      </button>
      <button id="idBtnDelete" class="ui red button" :disabled="action_closed || btnEditAction"
        v-on:click="deleteAction">
        <i class="large icons">
          <i class="trash alternate icon"></i>
        </i>
      </button>
    </div>
    <div v-if="data" class="ui segment">
      <form class="ui form">
        <div class="three fields">
          <div class="field">
            <label>Fecha Actuación</label>
            <input v-if="!btnEditAction" type="text" v-model="data.action_date" class="inputText" readonly>
            <input v-if="btnEditAction" type="datetime-local" id="idActDate" v-model="data.action_date"
              placeholder="Fecha actuación">
          </div>


          <div class="field">
            <label>Tipo Actuación</label>
            <input type="text" v-model="data.type" readonly>
            <div v-if="data.action_type_key === 'desinstalacion'" class="ui toggle checkbox" style="padding-top: 10px;">
              <input v-if="btnEditAction && !action_closed" type="checkbox" name="public" v-model="data.provisional">
              <input v-else type="checkbox" name="public" v-model="data.provisional" disabled="disabled">
              <label>Provisional</label>
            </div>
          </div>


          <div class="field">
            <label>Creador de la actuación</label>
            <input type="text" v-model="data.creator_name" readonly>
          </div>
        </div>
      </form>
    </div>

    <div v-if="data" class="ui stackable three column divided grid container">
      <div class="row">
        <div class="column">
          <h4 class="ui dividing header">Datos Máquina</h4>
          <div class="form ui">
            <div class="field">
              <label>Nombre</label>
              <input type="text" v-model="data.apm_name" readonly>
            </div>
            <div class="field">
              <label>Hostname</label>
              <input type="text" v-model="data.hostname" readonly>
            </div>
            <div class="field">
              <label>Modelo</label>
              <input type="text" v-model="data.apt_model" readonly>
            </div>
            <div class="field">
              <label>Pais</label>
              <input type="text" v-model="data.country" readonly>
            </div>
          </div>
        </div>

        <div class="column">
          <h4 class="ui dividing header">Datos Actuación</h4>
          <div class="form ui">
            <div class="field">
              <label>Cliente</label>
              <input v-if="!btnEditAction" type="text" class="inputText" readonly v-model="data.client_name">
              <sui-dropdown v-else placeholder="client" search selection :options="clientsOptions"
                v-model="data.client" />
            </div>
            <div class="field">
              <label>Proveedor de actuaciones</label>
              <input v-if="!btnEditAction" type="text" class="inputText" readonly v-model="data.action_provider">
              <sui-dropdown v-else placeholder="prov" search selection :options="providersOptions"
                v-model="data.action_provider_id" />
            </div>
            <div class="field">
              <label>Imputación</label>
              <input v-if="!btnEditAction" type="text" class="inputText" readonly v-model="data.imputation">
              <sui-dropdown v-else placeholder="Imputación" search selection :options="imputationsOptions"
                v-model="data.imputation_id" />
            </div>
            <div class="field">
              <label>Nº Ticket</label>
              <input type="text" class="inputText" :readonly="!btnEditAction" v-model="data.n_ticket">
            </div>

            <div class="ui segment">
              <div class="field">
                <label>Envío Columnas/Piezas</label>
                <selectOption :theFirstOption="firstOption" :theSecondOption="secondOption"
                  :theDisabledOption="!btnEditAction" v-model="data.send_stock"></selectOption>
              </div>
              <div class="field" v-if="data.send_stock">
                <label>Fecha Envío</label>
                <input v-if="!btnEditAction" type="text" id="idSendDate" v-model="data.send_date" class="inputText"
                  readonly>
                <input v-if="btnEditAction" type="datetime-local" id="idSendDate" v-model="data.send_date"
                  placeholder="Fecha envío">
              </div>
              <div class="field" v-if="data.send_stock">
                <label>Transportista</label>
                <input v-if="!btnEditAction" type="text" class="inputText" readonly v-model="data.courier_name">
                <sui-dropdown v-else search selection id="idCourier" :options="couriersOptions" v-model="data.courier"
                  placeholder="Transportista" />
              </div>
              <div class="field" v-show="data.send_stock">
                <label>Nº Palets</label>
                <input type="text" class="inputText" :readonly="!btnEditAction" id="idPalets" v-model="data.n_palets">
              </div>
              <div class="field" v-show="data.send_stock">
                <label>Aduana</label>
                <input type="text" class="inputText" :readonly="!btnEditAction" v-model="data.customs">
              </div>
            </div>

            <div class="field">
              <label>Descripción</label>
              <textarea class="inputText" :readonly="!btnEditAction" rows="4" maxlength="2000"
                v-model="data.observations"></textarea>
            </div>
          </div>
        </div>

        <div class="column">
          <h4 class="ui dividing header">Datos Facturación</h4>
          <div class="form ui">
            <div class="field">
              <label>Nº Factura Proveedor</label>
              <input type="text" class="inputText" :readonly="!btnEditAction" v-model="data.factura_proveedor">
            </div>
            <div class="field">
              <label>Precio Proveedor</label>
              <div class="ui right labeled input">
                <input type="text" id="idImputationCost" class="inputText" :readonly="!btnEditAction"
                  v-model="data.imputation_cost_provider" min="0"
                  v-on:keydown="validateNumericInput($event, data.imputation_cost_provider)">
                <div class="ui basic label">€</div>
              </div>
            </div>
            <div class="field">
              <label>Precio Hapiick</label>
              <div class="ui right labeled input">
                <input type="text" id="idCostAction" class="inputText" :readonly="!btnEditAction"
                  v-model="data.cost_action_hapiick" min="0"
                  v-on:keydown="validateNumericInput($event, data.cost_action_hapiick)">
                <div class="ui basic label">€</div>
              </div>
            </div>
            <div class="field">
              <label>Nº Factura Venta</label>
              <input type="text" class="inputText" :readonly="!btnEditAction" v-model="data.factura_venta">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.data && btnEditAction" class="ui stackable one column">
      <div class="row" id="idBtnAction">
        <button id="idSaveAction" class="ui green button" @click="editActionApt">
          <i class="check icon"></i>
          Guardar Actuacion
        </button>
        <button id="idCancelSaveAction" class="ui red button" @click="cancelEditActionApt">
          <i class="close icon"></i>
          Cancelar modificación
        </button>
      </div>
    </div>

    <div v-if="data && action.flujo_stock !== 'X'" class="ui stackable one column">
      <div class="row">
        <h4 class="ui dividing header">Stock</h4>
        <div class="form ui">
          <div v-if="(storesOptions.length > 0 && (stockNameOptions.length > 0 || columnNamesOptions.length > 0))"
            class="field" id="idStocks">
            <selectStock :theIsNew="isNew" :theBlockStock="action_closed" :theFlujoStock="action.flujo_stock"
              :theActionTypeKey="action.action_type_key" :theStores="storesOptions" :theStockNames="stockNameOptions"
              :theColumnNames="columnNamesOptions" :theStockSelected="stocksSelected" :theLetAddItem="letAddItem"
              :allowEdit="true" v-model="data.stock" @stockSelected="stockSelected"></selectStock>
          </div>
        </div>
      </div>
      <div class="row" id="idBtn" v-if="showActStockBtn">
        <button id="idSaveStock" class="ui button" v-on:click="saveActStock">
          <i class="edit outline icon"></i>
          Actualizar stock
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
import { isCurrencyLocalFormat, convertCurrencyToDDBB, convertCurrencyFromDDBB } from '@/tools/Utils.js'
import selectOption from '@/components/selectOption.vue'
import selectStock from '@/components/selectStock.vue'
export default {
  name: 'actionInfo',
  props: ['id'],
  data() {
    return {
      data: null,
      search: {},
      btnEditAction: true,
      clientsOptions: [],
      apmsOptions: [],
      imputationsOptions: [],
      storesOptions: [],
      typesOptions: [],
      providersOptions: [],
      couriersOptions: [],
      action: null,
      firstOption: "Si",
      secondOption: "No",
      stockNameOptions: [],
      stockIdentifiersOptions: [],
      columnNamesOptions: [],
      columnIdentifiersOptions: [],
      stocksSelected: [],
      actStock: false,
      showActStockBtn: false,
      isNew: false,
      isBtnCloseActionLoading: false,
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role;
    if (role === 'master' || role === 'admin') {
      this.initializeComponent();
    } else {
      this.$router.replace('/inventory')
    }
  },
  computed: {
    txtBtnCloseAction: function () {
      return (this.data.action_status === 'closed') ? 'Actuación finalizada' : 'Finalizar actuación'
    },
    action_closed: function () {
      return this.data.action_status === 'closed'
    },
    letAddItem: function () {
      return this.action.flujo_stock === 'E'
    },
  },
  methods: {
    saveActStock() {
      if (this.actStock) {
        if (this.validateForm(this.data)) {
          let btnSaveStock = document.getElementById("idSaveStock");
          btnSaveStock.classList.add("loading");
          btnSaveStock.disabled = true;
          hapiickApi().post('/v1/actions/stocks/edit', {
            admin_id: JSON.parse(localStorage.admin).id,
            action_apt_id: this.id,
            stocks: this.data.stock
          })
            .then(request => {
              if (request.data.status !== 'OK') {
                this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'No se ha podido modificar el stock de la actuación'
                })

                btnSaveStock.classList.remove("loading");
                btnSaveStock.disabled = false;
              } else {
                this.$swal({
                  type: 'success',
                  title: 'Actualizado!',
                  text: 'El stock de la actuación se han modificado correctamente',
                  showConfirmButton: false,
                  timer: 2500
                })
                btnSaveStock.classList.remove("loading");
                btnSaveStock.disabled = false;

                this.initializeComponent();
              }
            }).catch((request) => {
              // console.log('error updating action apt stocks')
              // console.log(request)
            })
        }
      }
    },
    cancelEditActionApt() {
      this.btnEditAction = false
      this.data = []
      this.data = { ...this.action }
    },
    editAction() {
      this.btnEditAction = true
    },

    closeAction() {
      this.$swal({
        title: '¿Quieres cerrar la actuacion?',
        text: 'Esta acción bloqueará el stock',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.dismiss) {
          return
        }

        if (!this.data.action_date || this.data.action_date.startsWith('0000')) {
          this.$swal.fire({
            type: 'warning',
            title: 'Campos obligatorios',
            text: 'La Fecha de Actuación no puede estar vacía.',
          })

          return false;
        }

        this.isBtnCloseActionLoading = true;
        hapiickApi().post('/v1/actions/stocks/block', {
          admin_id: JSON.parse(localStorage.admin).id,
          id: this.id,
          bloquear_stock: true
        })
          .then(request => {
            if (request.data.status === 'OK') {
              this.$swal({
                type: 'success',
                title: 'La actuación ahora está cerrada',
                showConfirmButton: false,
                timer: 2500
              })

              this.initializeComponent();
            } else {
              this.$swal({
                type: 'error',
                title: 'Error',
                text: 'No se ha podido cerrar la actuación'
              })
            }
          })
          .catch((request) => {
            this.$swal({
              type: 'error',
              title: 'Error',
              text: 'No se ha podido cerrar la actuación'
            });
          }
          )
          .finally(() => {
            this.isBtnCloseActionLoading = false;
          });
      })
    },

    initializeComponent() {
      this.data = null
      this.actStock = false
      this.stockNameOptions = []
      this.stockIdentifiersOptions = []
      this.columnNamesOptions = []
      this.columnIdentifiersOptions = []
      this.storesOptions = []
      this.showActStockBtn = false
      this.btnEditAction = false
      this.imputationsOptions = []
      this.apmsOptions = []
      this.clientsOptions = []
      this.couriersOptions = []
      this.providersOptions = []
      this.isBtnCloseActionLoading = false

      this.getDataFilters()
      this.getAction();


    },
    initializeStyles() {
      let borderNone = "border-color: none !important"

      if (this.btnEditAction) {
        if (this.data.send_stock) {
          document.getElementById("idSendDate").style = borderNone
          document.getElementById("idCourier").style = borderNone
        }
        document.getElementById("idImputationCost").style = borderNone
        document.getElementById("idCostAction").style = borderNone
      }

      if (this.action.apm && this.action.action_type) {
        document.getElementById("idStocks").style = borderNone
      }
    },
    validateNumericInput(event, value) {
      const key = event.key

      const allowedKeys = ['Tab', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', '.']
      const isAllowedKey = allowedKeys.includes(key)
      const isNumericKey = /^[0-9]$/.test(key)
      const isUniqueComma = (key === ',') && !value.includes(',')

      if (isAllowedKey || isNumericKey || isUniqueComma) return

      event.preventDefault()
    },
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        HapiickClient: true,
        Apt: true,
        Imputation: true,
        ActionProvider: true,
        ActionCourier: true,
        Store: true
      })
        .then(request => {
          this.stores = JSON.parse(JSON.stringify(request.data.data.stores));

          this.fillClientsOptions(JSON.parse(JSON.stringify(request.data.data.clients)));
          this.fillApmsOptions(JSON.parse(JSON.stringify(request.data.data.apms)));
          this.fillImputationsOptions(JSON.parse(JSON.stringify(request.data.data.imputations)));
          this.fillProvidersOptions(JSON.parse(JSON.stringify(request.data.data.providers)));
          this.fillCouriersOptions(JSON.parse(JSON.stringify(request.data.data.couriers)));
          this.fillStoresOptions(JSON.parse(JSON.stringify(request.data.data.stores)));
        })
        .catch(() => console.log('error getting clients and apms'))
    },
    async getAction() {
      this.search.id = this.id
      await hapiickApi().post('/v1/actions/search', {
        admin_id: JSON.parse(localStorage.admin).id,
        search: this.search
      })
        .then(request => {
          this.actionInfo(request)
        })
        .catch(
          (request) => {
            this.$swal({
              type: 'error',
              title: 'Error',
              text: 'Error getting action apt'
            });
          }
        )
    },
    actionInfo(req) {
      console.log({ req })
      this.action = JSON.parse(JSON.stringify(req.data.data.actions[0]))

      this.stocksSelected = []
      if (this.action.flujo_stock !== 'X') {
        this.getStocksByApt(this.action.apm, this.action.flujo_stock)
      } else {
        this.loadData()
      }
    },
    loadData() {
      this.data = { ...this.action }

      if ((this.action.imputation_cost_provider)) {
        this.data.imputation_cost_provider = convertCurrencyFromDDBB(this.action.imputation_cost_provider)
      }
      if ((this.action.cost_action_hapiick)) {
        this.data.cost_action_hapiick = convertCurrencyFromDDBB(this.action.cost_action_hapiick)
      }
    },
    stockSelected(options) {
      this.data.stock = options
      let orig = JSON.stringify(this.stocksSelected)
      let act = JSON.stringify(this.data.stock)

      if (orig !== act) {
        this.actStock = true
        this.showActStockBtn = true
      } else {
        this.showActStockBtn = false
        this.actStock = false
      }
    },
    async getStocksByApt(apt_id, flujo_stock) {
      await hapiickApi().post('/v1/stocks/get-by-apt', {
        admin_id: JSON.parse(localStorage.admin).id,
        apt_id: apt_id,
        flujo_stock: flujo_stock
      })
        .then(request => {
          const stocks_orig = JSON.parse(JSON.stringify(request.data.stocks));
          if (stocks_orig.length > 0) {
            this.fillStocksOptions(stocks_orig)
          } else {
            this.stockNameOptions.push({
              'text': 'No hay repuestos para el modelo de esta máquina',
            })
            this.columnNamesOptions.push({
              'text': 'No hay columnas para el modelo de esta máquina',
            })
          }
        }).catch((request) => {
          // console.log('error getting stocks')
          // console.log(request)
        })

      this.loadStockSelected(this.action.stock)
      this.loadData()
    },
    loadStockSelected(stocks) {
      this.stocksSelected = []

      stocks.forEach((val) => {
        let aux = {}

        aux['id'] = val.stock_product_id
        aux['key'] = val.stock_product_id
        aux['stock_product_id'] = val.stock_product_id
        aux['stock_id'] = val.StockProduct.stock_id
        aux['store_id'] = val.store_id
        aux['name'] = val.StockProduct.Stock.name
        aux['stockType'] = val.StockProduct.Stock.stock_type
        aux['store_name'] = val.Store.name
        aux['apt_id'] = val.StockProduct.apt_id
        aux['quantity'] = val.StockProduct.quantity
        aux['nSlots'] = val.StockProduct.Stock.n_slots
        aux['desglose'] = val.StockProduct.Stock.desglose
        aux['quantitySelected'] = val.quantity
        aux['quantitySelected_orig'] = val.quantity
        aux['product_identifier'] = val.StockProduct.product_identifier
        aux['product_identifier_prov'] = val.StockProduct.product_identifier_prov
        aux['value'] = val.stock_product_id
        aux['text'] = val.StockProduct.Stock.name + ' (' + val.StockProduct.quantity + ')'

        this.stocksSelected.push(aux)
      });
    },

    fillStocksOptions(stocks) {
      this.stockNameOptions = []
      this.stockIdentifiersOptions = []
      this.columnNamesOptions = []
      this.columnIdentifiersOptions = []
      let store_name = ''

      for (let i = 0; i < stocks.length; i++) {
        const comboOption = stocks[i].stock_type === 'R' ? this.stockNameOptions : this.columnNamesOptions;
        for (let j = 0; j < stocks[i].StockProduct.length; j++) {
          if (this.action.flujo_stock !== 'E') {
            store_name = this.storesOptions.find((e) => (e.value == stocks[i].StockProduct[j].store_id)).text
          }
          let exist = undefined

          if (comboOption.length > 0) {
            exist = comboOption.find((e) => (e.id == stocks[i].id && e.store_id == stocks[i].StockProduct[j].store_id))
          }
          if (exist) {
            comboOption.map((a) => {
              if ((a.id == stocks[i].id && a.store_id == stocks[i].StockProduct[j].store_id)) {
                a.identificadores.push(this.mountIdentifierOption(store_name, stocks[i], stocks[i].StockProduct[j]))
                a.text = stocks[i].name + ' (' + a.identificadores.length + ')'
                a.quantity = a.identificadores.length
              }
              return a
            })
          } else {
            let aux = {}
            aux['id'] = stocks[i].id
            aux['value'] = stocks[i].id
            aux['key'] = stocks[i].id
            aux['name'] = stocks[i].name
            aux['stockType'] = stocks[i].stock_type
            aux['nSlots'] = stocks[i].n_slots
            aux['store_id'] = stocks[i].StockProduct[j].store_id
            aux['store_name'] = store_name
            aux['desglose'] = stocks[i].desglose
            aux['identificadores'] = []
            aux['identificadores'].push(this.mountIdentifierOption(store_name, stocks[i], stocks[i].StockProduct[j]))
            aux['quantity'] = stocks[i].StockProduct[j].quantity
            if (stocks[i].desglose) {
              aux['text'] = stocks[i].name + ' (' + aux['identificadores'].length + ')'
            } else {
              aux['text'] = stocks[i].name + ' (' + stocks[i].StockProduct[j].quantity + ')'
            }
            comboOption.push(aux)
          }
        }
      }
    },
    mountIdentifierOption(store_name, stock, identifier) {
      let identificador = {}

      identificador['id'] = identifier.id
      identificador['key'] = identifier.id
      identificador['stock_product_id'] = identifier.id
      identificador['stock_id'] = identifier.stock_id
      identificador['store_id'] = identifier.store_id
      identificador['name'] = stock.name
      identificador['stockType'] = stock.stock_type
      identificador['store_name'] = store_name
      identificador['apt_id'] = identifier.apt_id
      identificador['quantity'] = identifier.quantity
      identificador['nSlots'] = stock.n_slots
      identificador['desglose'] = stock.desglose
      identificador['quantitySelected'] = 1
      identificador['product_identifier'] = identifier.product_identifier
      identificador['product_identifier_prov'] = identifier.product_identifier_prov
      identificador['value'] = identifier.id
      identificador['text'] = (identifier.product_identifier_prov) ? identifier.product_identifier_prov : identifier.product_identifier

      return identificador
    },
    deleteAction() {
      this.btnEditAction = false
      this.$swal.fire({
        type: 'question',
        title: '¿Estas seguro que quieres borrar la actuación?',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          let editBtn = document.getElementById("idBtnEditAction");
          editBtn.disabled = true;
          let deleteBtn = document.getElementById("idBtnDelete");
          deleteBtn.classList.add("loading");
          deleteBtn.disabled = true;
          hapiickApi().post('/v1/actions/delete', {
            admin_id: JSON.parse(localStorage.admin).id,
            id: this.id
          })
            .then(request => {
              if (request.data.status !== 'OK') {
                this.$swal({
                  type: 'error',
                  title: 'Error',
                  text: 'No se han podido eliminar la actuación'
                })
                editBtn.disabled = false;
                deleteBtn.classList.remove("loading");
                deleteBtn.disabled = false;
                return
              }
              this.$swal({
                type: 'success',
                title: 'Eliminado!',
                text: 'La actuación se han eliminado correctamente',
                showConfirmButton: false,
                timer: 2500
              })
              this.goTo('/inventory/action/list')
            })
            .catch((request) => {
              this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Error al eliminar la actuación'
              });
              editBtn.disabled = false;
              deleteBtn.classList.remove("loading");
              deleteBtn.disabled = false;
            })
        }
      })
    },
    validateForm(data) {
      this.initializeStyles();

      let next = true;

      let borderError = "border: 1px solid red !important"

      if (data.send_stock) {
        if (!data.send_date) {
          document.getElementById("idSendDate").style = borderError
          next = false
        }
        if (!data.courier) {
          document.getElementById("idCourier").style = borderError
          next = false
        }
      }

      if (this.action.flujo_stock === 'E') {
        if (data.stock) {
          data.stock.forEach(element => {
            if (element.store_id == 0) {
              next = false
              document.getElementById("idStocks").style = borderError
            }
          });
        }
      }

      if (!next) {
        this.$swal.fire({
          type: 'warning',
          title: 'Camos obligatorios',
          text: 'Falta uno o varios campos obligatorio. '
        })

        return false;
      }

      if (!isCurrencyLocalFormat(data.imputation_cost_provider)) {
        document.getElementById("idImputationCost").style = borderError
        next = false
      }

      if (!isCurrencyLocalFormat(data.cost_action_hapiick)) {
        document.getElementById("idCostAction").style = borderError
        next = false
      }

      if (!next) {
        this.$swal.fire({
          type: 'warning',
          title: 'Formato incorrecto',
          text: 'El formato correcto para los importes es: #.###,##'
        })
      }

      return next
    },
    editActionApt() {
      if (this.validateForm(this.data)) {
        let edit_data = { ... this.data };
        delete (edit_data.stock)
        if (edit_data.imputation_cost_provider) {
          edit_data.imputation_cost_provider = convertCurrencyToDDBB(edit_data.imputation_cost_provider)
        }
        if (edit_data.cost_action_hapiick) {
          edit_data.cost_action_hapiick = convertCurrencyToDDBB(edit_data.cost_action_hapiick)
        }

        let btnSaveAction = document.getElementById("idSaveAction");
        btnSaveAction.classList.add("loading");
        btnSaveAction.disabled = true;
        let btnCalcelSaveAction = document.getElementById("idCancelSaveAction");
        btnCalcelSaveAction.disabled = true;

        hapiickApi().post('/v1/actions/edit', {
          admin_id: JSON.parse(localStorage.admin).id,
          data: edit_data
        })
          .then(request => {
            if (request.data.status === 'OK') {
              this.$swal({
                type: 'success',
                title: 'Datos actualizados',
                showConfirmButton: false,
                timer: 2500
              })

              btnSaveAction.classList.remove("loading");
              btnSaveAction.disabled = false;
              btnCalcelSaveAction.disabled = false;

              this.initializeComponent();
            } else {
              this.$swal({
                type: 'error',
                title: 'Error',
                text: 'No se ha podido modificar la actuación'
              })

              btnSaveAction.classList.remove("loading");
              btnSaveAction.disabled = false;
              btnCalcelSaveAction.disabled = false;
            }
          })
          .catch(
            (request) => {
              this.$swal({
                type: 'error',
                title: 'Error',
                text: 'No se han podido modificar la actuación'
              });
              btnSaveAction.classList.remove("loading");
              btnSaveAction.disabled = false;
              btnCalcelSaveAction.disabled = false;
            }
          )
      }
    },
    fillProvidersOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.providersOptions.push({
          key: data[i].ActionProvider.key,
          text: data[i].ActionProvider.name,
          value: data[i].ActionProvider.id
        })
      }
    },
    fillCouriersOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.couriersOptions.push({
          key: data[i].ActionCourier.key,
          text: data[i].ActionCourier.name,
          value: data[i].ActionCourier.id
        })
      }
    },
    fillClientsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.clientsOptions.push({
          key: data[i].HapiickClient.key,
          text: data[i].HapiickClient.name,
          value: data[i].HapiickClient.id
        })
      }
    },
    fillApmsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.apmsOptions.push({
          key: data[i].Apt.id,
          text: data[i].LanguagesApts[0].name,
          value: data[i].Apt.id,
          apt_model_id: data[i].Apt.apt_model_id
        })
      }
    },
    fillImputationsOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.imputationsOptions.push({
          key: data[i].Imputation.key,
          text: data[i].Imputation.name,
          value: data[i].Imputation.id,
        })
      }
    },
    fillStoresOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.storesOptions.push({
          key: data[i].Store.key,
          text: data[i].Store.name,
          value: data[i].Store.id,
        })
      }
    },
    goTo(where) {
      this.$router.push(where)
    },
  },
  components: {
    'selectOption': selectOption,
    'selectStock': selectStock
  }
}
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-wsebkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

#idBtn {
  text-align: center;
  margin-top: 20px;
}

#idEdit,
#idSaveStock {
  background-color: black !important;
  color: white;
  width: 35%;
}

.ui.selection.dropdown {
  min-width: 100% !important;
}

/* #idBtnEditAction {
    margin-right: 20px;
  } */
.margin-button {
  margin-right: 20px !important;
}

.panelNagusia {
  padding-bottom: 2rem !important;
}

#idBtnAction {
  padding: 20px;
  text-align: center;
}

#idBtnAction button {
  width: 35%
}

#idCheckProvisional {
  padding-top: 10px;
  align-items: center;
  display: flex;
}

.ui.form .fields {
  margin: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/actionInfo.vue